<template>
  <div class="cargene">
    <div class="area_box" v-for="item in list" :key="'list_' + item.id" @click="selectModel(item.id,item.title)">
      <img class="area_pic" :src="item.pic">
      <div class="area_titie">{{item.title}}</div>
      <img class="arrow" :src="img.arrow">
    </div>
    <div class="addmodels text-c" @click="showDialog">没有我的代系，<span style="color:#605C6B">填写我的代系</span></div>
    <van-popup v-model="show">
      <div class="block">
        <div class="text-c f-16 mb-20">我的代系</div>
        <van-field v-model="carare" placeholder="代系" />
        <van-field v-model="model" placeholder="车型" />
        <van-button type="default" size="large" color="#605C6B" style="margin-top: 30px;" @click="submit">确认提交</van-button>
      </div>
    </van-popup>

  </div>
</template>
<script>
  import list from '../../../api/member/mycars';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import {Cell, CellGroup,Popup,Field,Toast,Button } from 'vant';
  export default {
    data () {
      return {
        show: false,
        list:[],
        ever:0,
        carare:'',
        model:'',
        img:{
          china: require('../../../assets/img/lexus/china.png'),
          foregin: require('../../../assets/img/lexus/foregin.png'),
          arrow: require('../../../assets/img/lexus/arrow.png'),
          travel: require('../../../assets/img/travel.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.region=this.$route.query.type
      this.ever=this.$route.query.ever
      this.id=this.$route.query.id
      this.name=this.$route.query.carname
      this.is_have_card=this.$route.query.is_have_card
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      this.weburl=process.env.VUE_APP_URL
      this.getGene()
      var params={
        event_code: '车主认证_选择代系',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/My/CarGene.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      getGene(){
        var params={
          car_id:this.id,
          region:this.region
        }
        list.getGene(params).then(res => {
          if(res.data.state == 1) {
            this.list=res.data.data
          }
        })
      },
      showDialog(){
        this.show=true
      },
      hideDialog(){
        this.show=false
      },
      submit(){
        if(this.carare==''){
          Toast('请填写代系');
        }else if(this.model==''){
          Toast('请填写车型');
        }else{
          var params={
            url:this.weburl+'/lexus/my/car_info?type='+this.region+ '&carname='+encodeURI('雷克萨斯 '+this.model)+'&source='+this.source+'&ever='+this.ever+'&id=' + this.id + '&car_generation_name=' + encodeURI(this.carare) + '&car_model_name=' + encodeURI(this.model)+'&is_have_card='+this.is_have_card,
            isReturn: true 
          }
          this.$appService.openWebView(params)
          this.show=false
        }
        
      },
      selectModel(id,name){
        var params={
          car_generation_id:id,
          car_id:this.id,
        }
        list.getModels(params).then(res => {
          if(res.data.state == 1) {
            var list=res.data.data
            if(list.length>0){
              var params={
                url:this.weburl+'/lexus/my/car_model?type='+this.region+'&id='+this.id+'&carname='+encodeURI(this.name)+'&gid='+id+'&source='+this.source+'&ever='+this.ever+'&is_have_card='+this.is_have_card,
                isReturn: true 
              }
              this.$appService.openWebView(params)
            }else{
              var params={
                url:this.weburl+'/lexus/my/car_info?type='+this.region+'&id='+this.id+ '&carname='+encodeURI(this.name)+'&gid='+id+'&source='+this.source+'&ever='+this.ever+'&is_have_card='+this.is_have_card,
                isReturn: true 
              }
              this.$appService.openWebView(params)
            }
          }
        })
      },
    },
    components: {
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Popup.name]:Popup,
      [Field.name]:Field,
      [Toast.name]:Toast,
      [Button.name]:Button
    }
  }
</script>
<style lang="scss">
.cargene{

  .area_box{
    display: flex;
    align-items: center;
    padding: 20px 0;
    border-bottom: 0.5px solid rgba(0,0,0,.1);
    margin:0 15px;
    .area_pic{
      width: 150px;
      height: 80px;
      margin-left: 20px;
    }
    .area_titie{
      flex: 1;
      font-size:14px;
      text-align: center;
    }
    .arrow{
      width: 10px;
      height: 12px;
      float: right;
    }
  }
  
  .knowBtn{
    width: 100%;
    height: 45px;
    color: #fff;
    background: #605C6B;
    font-size: 14px;
    font-weight: 400;
    margin-top: 10px;
  }
  .addmodels{
    padding: 25px;
    font-size: 14px;
  }
  .van-popup{
    width: 80%;
    min-height: 120px;
    padding: 15px;
    .mb-20{
      margin-bottom: 20px
    }
    .van-field{
      background-color: #EEEEEE;
      border-radius: 1px;
      margin-top: 15px;
    }
  }
}
</style>
